import { render, staticRenderFns } from "./questionAnswer.vue?vue&type=template&id=9055e1c4&scoped=true"
import script from "./questionAnswer.vue?vue&type=script&lang=js"
export * from "./questionAnswer.vue?vue&type=script&lang=js"
import style0 from "./questionAnswer.vue?vue&type=style&index=0&id=9055e1c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055e1c4",
  null
  
)

export default component.exports